<app-dialog
  [headerGlyph]="headerIcon"
  [headerText]="title"
  saveText="Move"
  [showTopCancelButton]="false"
  [body]="body"
  (save)="onMove()"
  [validationFn]="validate.bind(this)"
>
  <ng-template #body>
    @if (!loading) {
      <div class="container">
        <div>{{ msg }}</div>
      </div>
    }
  </ng-template>
</app-dialog>
